'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'googleMap', () => {

		let mapInstance = null;

		return {

			activeIndex        : 0,
			zoom               : 16,
			centerOffsetPercent: 0,
			customMarker       : '<svg width="248" height="248" viewBox="0 0 248 248" fill="none" xmlns="http://www.w3.org/2000/svg" class="map-marker"><circle class="map-marker__ring map-marker__ring--1" cx="124" cy="124" r="5.5" fill="#0680FF"/><circle class="map-marker__ring map-marker__ring--2" cx="124" cy="124" r="5.5" fill="#0680FF"/><circle class="map-marker__ring map-marker__ring--3" cx="124" cy="124" r="5.5" fill="#0680FF"/><circle cx="124" cy="124" r="5.5" fill="#0680FF" stroke="white"/></svg>',

			init() {

				if ( window.avincGoogleMaps && window.avincGoogleMaps.mapsReady ) {
					this.initMap();
				} else {
					document.addEventListener( 'avinc:maps-ready', () => this.initMap(), { once: true });
				}
			},

			initMap() {

				const mapEl    = this.$el.querySelector( '.acf-map' );
				const $markers = mapEl.querySelectorAll( '.marker' );

				let mapId = '';

				if ( mapEl.dataset.mapId ) {
					mapId = mapEl.dataset.mapId;
				} else if ( window.avincGoogleMaps && window.avincGoogleMaps.mapId ) {
					mapId = window.avincGoogleMaps.mapId;
				}

				this.zoom = mapEl.dataset.zoom ? parseInt( mapEl.dataset.zoom, 10 ) : 16;
				this.centerOffsetPercent = mapEl.dataset.centerOffsetX ? parseFloat( mapEl.dataset.centerOffsetX ) : 0;

				const mapArgs = {
					zoom            : this.zoom,
					center          : new google.maps.LatLng( 0, 0 ),
					disableDefaultUI: true,
				};

				if ( mapId ) {
					mapArgs.mapId = mapId;
				}

				if ( mapEl.dataset.gestureHandling ) {
					mapArgs.gestureHandling = mapEl.dataset.gestureHandling;
				}

				const map = new google.maps.Map( mapEl, mapArgs );

				map.markers = [];
				mapInstance = map;

				$markers.forEach( ( $marker ) => {

					const lat     = parseFloat( $marker.dataset.lat );
					const lng     = parseFloat( $marker.dataset.lng );
					const content = document.createElement( 'div' );
					content.innerHTML = this.customMarker || '';

					const marker = new google.maps.marker.AdvancedMarkerElement({
						position  : { lat, lng },
						map       : map,
						content   : content.firstElementChild,
						anchorLeft: '-50%',
						anchorTop : '-50%',
					});

					map.markers.push( marker );

					if ( $marker.innerHTML ) {
						const infowindow = new google.maps.InfoWindow({
							content: $marker.innerHTML,
						});

						marker.addListener( 'click', () => {
							infowindow.open( map, marker );
						});
					}
				});

				this.panToMarker( 0 );
			},

			panToMarker( index ) {

				this.activeIndex = index;

				if ( mapInstance && mapInstance.markers[ index ] ) {
					mapInstance.setCenter( mapInstance.markers[ index ].position );
					mapInstance.setZoom( this.zoom );

					if ( this.centerOffsetPercent ) {
						const offsetPercent = this.centerOffsetPercent;

						google.maps.event.addListenerOnce( mapInstance, 'idle', () => {
							const mapWidth = mapInstance.getDiv().offsetWidth;

							mapInstance.panBy( -mapWidth * ( offsetPercent / 100 ), 0 );
						});
					}
				}
			},

			centerMap( map ) {

				const bounds = new google.maps.LatLngBounds();

				map.markers.forEach( ( marker ) => {
					bounds.extend( marker.position );
				});

				if ( 1 === map.markers.length ) {
					map.setCenter( bounds.getCenter() );
					map.setZoom( 16 );
				} else {
					map.fitBounds( bounds );
				}
			},
		};
	});
});
